export enum RaffleDefaultTicketTransactionStatusTypesEnum {
  PAID = "p",
  WAITING = "w",
  FAILED = "f",
  DELETED = "x",
  EXPIRED = "e",
}

export type RaffleDefaultTicketTransactionStatusTypes =
  `${RaffleDefaultTicketTransactionStatusTypesEnum}`;
